import type { HTMLAttributes, PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

type Variant =
  | "neutral"
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "primary"
  | "court";

type Props = PropsWithChildren<
  HTMLAttributes<HTMLSpanElement> & { variant?: Variant; dot?: boolean }
>;

const variants: Record<Variant, string> = {
  neutral: "bg-slate-100 text-slate-700",
  success: "bg-moving-100 text-moving-700",
  info: "bg-sky-100 text-sky-700",
  warning: "bg-amber-100 text-amber-700",
  danger: "bg-red-100 text-red-700",
  primary: "bg-moving-500 text-white",
  court: "bg-court-500 text-white",
};

export function Badge({
  variant = "neutral",
  dot = false,
  className,
  children,
  ...rest
}: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium",
        variants[variant],
        className,
      )}
      {...rest}
    >
      {dot ? (
        <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      ) : null}
      {children}
    </span>
  );
}
